import AppLayout from "../components/common/AppLayout";

export default function CuentasPagarPage() {
    return (
        <AppLayout title="Cuentas por pagar">
            <div className="card-panel">
                <h3>Módulo en construcción</h3>
                <p>Aquí irá la gestión de cuentas por pagar, pagos y control de vencimientos.</p>
            </div>
        </AppLayout>
    );
}